import { useContext } from 'react';

import AuthContext from 'src/contexts/AmplifyAuthContext';

const useAuth = () => useContext(AuthContext);

export default useAuth;
